import { useState } from "react";
import { Button, CircularProgress, Stack } from "@mui/material";
import { getAuth } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { getFunctions } from "firebase/functions";
import { db } from "../../firebase";
import { deleteDoc, doc } from "firebase/firestore";
import { showCustomToast } from "../Misc/CustomToast";

const DeleteUserModal = (props) => {
  const functions = getFunctions();
  const [isLoading, setIsLoading] = useState(false);
  const auth = getAuth();
  const user = auth.currentUser;
  const nameUser = user.displayName;

  const deleteUserFunction = httpsCallable(functions, "deleteUser"); // Renommé deleteUserFunction

  const handleDeleteUser = async () => {
    // Fonction asynchrone
    setIsLoading(true);
    try {
      // Effacer l'utilisateur de l'authentification
      await deleteUserFunction({ uid: props.uid });

      // Effacer les données de l'utilisateur de Firestore

      const userDoc = doc(db, "roles", props.uid);
      await deleteDoc(userDoc);

      // Afficher un toast de succès
      showCustomToast("User deleted successfully.", "success");

      setIsLoading(false);
      props.onClose();
    } catch (error) {
      // Une erreur s'est produite lors de la suppression de l'utilisateur
      console.error("Error deleting user: ", error);
      setIsLoading(false);

      // Afficher un toast d'erreur
      showCustomToast("Error deleting user.", "error");
    }
  };

  return (
    <>
      <div style={{ padding: "4px 4px 12px 4px" }}>
        <div style={{ color: "#374151", fontSize: 14, lineHeight: 1.5 }}>
          Are you sure you want to delete this user?
          <br />
          <span style={{ opacity: 0.8 }}>
            ({nameUser}) : {props.uid}
          </span>
        </div>
      </div>

      <Stack direction="row" justifyContent="flex-end" spacing={1}>
        <Button variant="outlined" onClick={props.onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={isLoading}
          onClick={handleDeleteUser}
        >
          {isLoading ? <CircularProgress size={18} /> : "Delete user"}
        </Button>
      </Stack>
    </>
  );
};

export default DeleteUserModal;
